<template>
    <div>
      <br />
      <h2 class="ViewHeading">Virtual Logbook</h2>
      <div>
        <b-row
          ><b-col>
            <h4>{{ this.selectedlocation }}</h4>
          </b-col></b-row
        >
  
        <b-row> </b-row>
      </div>
      <div>
        <b-card>
          <b-tabs>
            <b-tab title="tab one">1</b-tab>
            <b-tab title="tab two">2</b-tab>
        
          </b-tabs>
        </b-card>
        <br />
      </div>
    </div>
  </template>
  
  <script>
  
  
  export default {
    data() {
      return {
        selectedlocation: localStorage.getItem("location"),
        UserAccess: localStorage.getItem("accessGroup"),
        UserURN: localStorage.getItem("UserURN"),
        UserProfile: localStorage.getItem("profileportal"),
        fullname: localStorage.getItem("fullname"),
      };
    },
  
    components: {},
    methods: {},
  };
  </script>
  <style scoped></style>
  